import React, { useContext } from 'react';
import { Icon } from '@iconify/react';
import { AuthContext } from '../../context/AuthContext';
import { ThemeContext } from '../../context/ThemeContext';
import { roleLabel } from '../../utils/format';

const Topbar = ({ isSidebarOpen, toggleSidebar }) => {
  const { user, logout } = useContext(AuthContext);
  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
    <header className="h-16 flex items-center justify-between px-4 md:px-6 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900">
      {/* Mobile menu toggle */}
      <button
        type="button"
        onClick={() => toggleSidebar(prev => !prev)}
        aria-label={isSidebarOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={!!isSidebarOpen}
        className="md:hidden h-10 w-10 flex items-center justify-center rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800"
      >
        <Icon icon="solar:hamburger-menu-linear" className="w-5 h-5 text-primary-black dark:text-white" aria-hidden="true" />
      </button>

      <div className="flex-1" />

      <div className="flex items-center gap-3">
        {/* Theme toggle */}
        <button
          type="button"
          onClick={toggleTheme}
          aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          className="h-10 w-10 flex items-center justify-center rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
          title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          <Icon
            icon={theme === 'dark' ? 'solar:sun-linear' : 'solar:moon-linear'}
            className="w-5 h-5 text-primary-black dark:text-white"
          />
        </button>

        {/* User info & logout */}
        <div className="flex items-center gap-2">
          <div className="hidden sm:block text-right">
            <p className="text-sm font-medium text-primary-black dark:text-white">
              {user?.first_name || user?.email || 'Admin'}
            </p>
            <p className="text-xs text-accent-gray">{roleLabel(user?.platform_role || user?.role) || 'Owner'}</p>
          </div>
          <button
            type="button"
            onClick={logout}
            aria-label="Sign out"
            className="h-10 w-10 flex items-center justify-center rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
            title="Sign out"
          >
            <Icon icon="solar:logout-2-linear" className="w-5 h-5 text-red-500" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Topbar;
